import { Component, input } from '@angular/core';
import { OfficeAgentsComponent } from '../modules/office-agents/office-agents.component';

@Component({
  selector: 'ava-office-agents-custom-element',
  template: ` <ava-office-agents [officeId]="officeId()" [params]="params()" /> `,
  standalone: true,
  imports: [OfficeAgentsComponent],
})
export class OfficeAgentsCustomElementComponent {
  officeId = input<string>();
  params = input<string>();
}
